import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../core/store';
import { Destroyable } from '../../../../core/util/destroyable';
import { Config } from '../../../../core/store/config/config.interface';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-launchpad-tile',
  templateUrl: './launchpad-tile.component.html',
  styleUrls: ['../common/orders-flows-tile.component.scss'],
})
export class LaunchpadTileComponent extends Destroyable {
  private launchpadUrl: string;

  constructor(protected store: Store<fromRoot.RootState>) {
    super();
    store
      .select('config')
      .pipe(takeUntil(this.destroyed$))
      .subscribe((config: Config) => {
        this.launchpadUrl = config.launchpadUrl;
      });
  }

  gotoLaunchpadClicked() {
    window.location.href = this.launchpadUrl;
  }
}
